<span
  nz-icon
  nzType="left"
  nzTheme="outline"
  (click)="onBack()"
  [ngClass]="{ 'has-action': hasAction }"
></span>
